import { createAction } from "@redux/actions/actionCreators";
import { NavPoint } from "@redux/navPoint/NavPoint";
import { RootState } from "@redux/store";
import { getVersionedIdentifier } from "@redux/utils/identifiers";
import { autoNormalize, EntitiesMap, KitVersion } from "@thenounproject/lingo-core";
import { DeepPartial } from "shared";

export type ServerData = DeepPartial<RootState>;
type Args = ServerData;

const [useHydrateStore, hydrateStore] = createAction<Args>("hydrateStore");

export default useHydrateStore;
export { hydrateStore };

export function hydrationDataFromNavPoint(navPoint: NavPoint): ServerData {
  const { entities = {} as EntitiesMap } = autoNormalize({
    space: navPoint.space,
    portal: navPoint.portal,
    section: navPoint.section,
    item: navPoint.item,
    gallery: navPoint.gallery,
    asset: navPoint.asset,
    kit: navPoint.kit,
    kit_version: navPoint.kitVersion,
    user: navPoint.user,
    product: navPoint.product,
  });

  if (navPoint.kitVersion) {
    const version =
      entities.kitVersions?.[
        getVersionedIdentifier(navPoint.kitVersion.kitUuid, navPoint.kitVersion.version)
      ];
    navPoint.kitVersion = version as KitVersion;
  }

  // Nest each entity under an objects key
  const hydratedEntities: Record<string, { objects: Record<string, unknown> }> = {};
  Object.entries(entities).forEach(([key, value]) => {
    hydratedEntities[key] = { objects: value };
  });

  return {
    navPoint: navPoint,
    user: navPoint.user,
    entities: hydratedEntities,
  };
}
